require('./_home/app.js');
require('./_certificate/app.js');
// require('./_recertification/app.js');
require('./_about/app.js');
require('./_best-project/app.js');
require('./_history/app.js');
require('./_partners/app.js');
require('./_unique-news/app.js');
require('./_contacts/index.js');
